import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { withRef } from '../../../utils';
export const NativeSelect = withRef(function NativeSelect({ id = `castor-native-select-${++idCount}`, className, invalid, ...restProps }, ref) {
    const { disabled, touched } = useField();
    return (React.createElement("select", { disabled: disabled, ...restProps, ref: ref, id: id, className: classy(c('select-native'), m({ invalid, touched }), className) }));
});
let idCount = 0;
//# sourceMappingURL=native-select.js.map